<template>
    <div class="menu-list">
        <center>
            <h2 class="h3">Lo más visto del mes</h2>
        </center>

        <div class="menu-col col-1">
            <ul>
                <li v-for="post in trending_posts" :key="post.id">
                    <a :href="goUrl(post.id)">
                        <span>
                            <a :href="goUrl(post.id)">
                                <img :src="checkImage(post.thumb, true)" class="blog" :alt="post.titulo">
                            </a>
                        </span>
                    </a>
                    <a :href="goUrl(post.id)">
                        <h4> {{ post.title }} </h4>
                    </a>
                    <p v-if="post.categoria">
                        <strong> {{ post.category.name }} </strong>
                    </p>
                    <p class="fecha">
                        {{ dateToStringShort(post.date) }}
                    </p>
                    <p>
                        {{ textTruncate(post.description, 148) }}
                    </p>
                </li>
            </ul>
        </div>
        
    </div>
</template>

<script>
import axios from '../axios'
import tools from '../tools'

export default {
    mounted() {
        this.getTrendingPosts()
    },
    data() {
        return {
            loading: false,
            trending_posts: []
        }
    },
    methods: {
        goUrl(id_post) {
            return this.$publicUrl + 'blog/post/' + id_post
        },
        getTrendingPosts() {
            this.loading = true
            axios.get('blog/trending').then(response => {
                this.trending_posts = response.data
                this.loading = false
            }).catch(error => {
                console.log(error.message)
            })
        },
        checkImage: tools.checkImage,
        dateToStringShort: tools.dateToStringShort,
        textTruncate: tools.textTruncate
    }
}
</script>